export default __webpack_public_path__ + "static/media/zoom.4ef72d64.svg";